export const CANVAS = "canvas";
export const EXTERNAL = "external";
export const QUALITATIVE = "qualitative";
export const EMBEDDED = "embedded";

export const emailVerification = (email) => {
  if (/\S+@\S+\.\S+/.test(email)) {
    return true;
  } else {
    return false;
  }
};

export function emailIsInList(existingEmails, newEmail) {
  return existingEmails.some(
    (item) =>
      item.localeCompare(newEmail, undefined, { sensitivity: "base" }) === 0
  );
}

export const evidenceFileTypes = [
  // Spreadsheets
  ".csv",
  ".xls",
  ".xlsx",
  // Text Files
  ".txt",
  ".pdf",
  ".doc",
  ".docx",
  // Images
  ".jpg",
  ".jpeg",
  ".png",
  // Audio
  ".mp3",
  ".wav",
  ".ogg",
  ".m4a",
  // Video
  ".mp4",
  ".mov",
  // Zip
  ".zip",
];
